<!-- 老师管理 -->
<template>
	<div class="fuzzy-matching-box">
		<!-- 老师管理 -->
		<div class="fuzzy-matching-top">
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="学校:">
						<!-- <el-input v-model="Dform.schoolName" placeholder=''></el-input> -->
						<el-select v-model="schoolListTopId" placeholder="请选择学校" @change="schoolClickTop"  @click="schoolPost(true)">
							<el-option :label="item.name" :value="item.id" v-for="item in schoolListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="school_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="年级:">
						<!-- <el-input v-model="Dform.gradeName" placeholder=''></el-input> -->
						<el-select v-model="gradeDataListTopId" placeholder="请选择年级" @change="classClickTop"  @click="gradePost()">
							<el-option :label="item.name" :value="item.id" v-for="item in gradeDataListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="grade_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="班级:">
						<!-- <el-input v-model="Dform.className" placeholder=''></el-input> -->
						<el-select v-model="classListTopId" placeholder="请选择班级" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in classListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="class_loading"><text>加载中...</text></div> -->
					</el-form-item>
				</el-col>
				
				<!-- <el-col :span="5">
					<el-form-item label="学科:">
						<!-- <el-input v-model="Dform.className" placeholder=''></el-input>
						<el-select v-model="classListTopId" placeholder="请选择学科" @click="classPost()">
							<el-option :label="item.name" :value="item.id" v-for="item in classListTop"
								:key="item.name"></el-option>
						</el-select>
						<!-- <div class="loading_view" v-if="class_loading"><text>加载中...</text></div>
					</el-form-item>
				</el-col> -->
			</el-row>
			
			<el-row class="top-first-line the-second-line">
				<el-col :span="5">
					<el-form-item label="用户名:">
						<el-input v-model="Dform.userName" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="姓名:">
						<el-input v-model="Dform.name" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
					<el-form-item label="号码:">
						<el-input v-model="Dform.mobile" placeholder=''></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="5">
				</el-col>
				<el-button type="primary" class="query-button" @click="entrylogClick">查询</el-button>
			</el-row>
			
			
		</div>
		<div class="fuzzy-matching-content">
			<!-- <el-button type="text" class="query-button" @click="AddClick" v-if=" teacherObj.schoolId ==null">新增学校管理员</el-button>
			<el-button type="text" class="query-button" @click="daoRuClick" v-if=" teacherObj.gradeId == null">新增年级管理员</el-button>
			<el-button type="text" class="query-button" @click="deriveFamily" v-if="teacherObj.classId ==null">新增班级管理员</el-button> -->
			<el-button type="text" class="query-button" @click="AddTeacher">新增教职工</el-button>
			<el-button type="text" class="query-button" @click="ExportTeacherInfo">批量导出</el-button>
			<el-button type="text" class="query-button" @click="bulk_import">批量导入</el-button>
			<el-button type="text" class="query-button" @click="xiazaiclick">模板下载</el-button>
		</div>
		
		<div class="upload-lef" v-if="upShow">
			<!-- <div @click="clickUpload">上传附件</div> -->
			<span class="upload-title">请选择要导入的数据文件：</span>
			<input class="upload" style="cursor: pointer;" id="inputFile" type="file" @change="getFile($event)" />
			<el-button type="primary" @click="uploadClick">上传</el-button>
		</div>
		
		<div class="fuzzy-matching-bottom">
				<el-table stripe :border="true" v-loading="loading"
					:header-cell-style="{background:'#EDF6FF',color:'#000',}" ref="multipleTable" :data="tableData"
					
					tooltip-effect="dark"  @selection-change="handleSelectionChange">
					<!-- <el-table-column label="类型" show-overflow-tooltip>
						<template #default="scope">
							<span v-if="scope.row.type == 0">{{'系统管理员'}}</span>
							<span v-if="scope.row.type == 1">{{'校长'}}</span>
							<span v-if="scope.row.type == 2">{{'年级主任'}}</span>
							<span v-if="scope.row.type == 3">{{'班主任'}}</span>
							<span v-if="scope.row.type == 4">{{'教职工'}}</span>
						</template>
					</el-table-column> -->
					<el-table-column prop="username" label="用户名">
					</el-table-column>
					<el-table-column prop="name" label='姓名'>
					</el-table-column>
					<el-table-column prop="mobile" label="手机">
					</el-table-column>
					<el-table-column prop="schoolName" label="学校">
					</el-table-column>
					<!-- <el-table-column prop="gradeName" label="年级">
					</el-table-column>
					<el-table-column prop="className" label="班级">
					</el-table-column> -->
					<el-table-column
						label="职位"
						:show-overflow-tooltip="true"
						style="word-break: break-word;"
						>
						<template #default="scope">
							<div class="box_le_zhi">
								<div>
									<!-- <span v-if="scope.row.type == 0">{{'系统管理员'}}</span>
									<span v-if="scope.row.type == 1">{{'校长'}}</span>
									<span v-if="scope.row.type == 2">{{'年级主任'}}</span>
									<span v-if="scope.row.type == 3">{{'班主任'}}</span>
									<span v-if="scope.row.type == 4">{{'教职工'}}</span> -->
								</div>
								<div v-for="item in scope.row.teacherJobList" :key="item.id">
									<span>{{item.subjectName == null? item.jobName :item.subjectName}} {{item.gradeName}} {{item.className}}</span>
								</div>
							</div>
						</template>
					</el-table-column>
					<!-- <el-table-column  label="可选科目" show-overflow-tooltip>
					  <template #default="scope">
					    <div v-if="scope.row.teacherJobList && scope.row.teacherJobList.length > 0">
					      {{ scope.row.teacherJobList.map(item => item.subjectName).join('、') }}
					    </div>
					  </template>
					</el-table-column> -->
					
					<el-table-column label="操作">
						<template #default="scope">
							<el-button type="text" size="small" class='textButton'
								@click="reviseClick(scope.row)">修改</el-button>
							<el-button type="text" size="small" class="shanchuBtn"
								@click="deleteClick(scope.row)">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<div class="block-fenye">
					<el-pagination :small="small" :disabled="disabled" :background="background"
						layout="prev, pager, next, jumper" :total="total" @size-change="handleSizeChange"
						@current-change="handleCurrentChange" />
				</div>
		</div>
		<AddSchoolAdministrator v-if="AddShow" :titleValue="titleValue" :detailsObj="detailsObj" @addClick="addClick">
		</AddSchoolAdministrator>
	</div>
</template>

<script>
	import {
		schoolOrUserManagementTeacherList,
		deleteTeacherInfo,
		ImporBulkTeacher,
		getTeacherSubject
	} from '@/assets/api/schoollog';
	import {
		exportTeacherInfo,
		findSchoolInfo,
		findTeacherInfo,
		findClassInfo,
		schoolList,
		gradeList,
		findClassList
	} from '@/assets/api/renyuan';
	import AddSchoolAdministrator from './group/add-school-administrator.vue'

	import {
		ElMessage
	} from 'element-plus'
	export default {
		components: {
			AddSchoolAdministrator
		},
		data() {
			return {
				teacherObj: {},
				loading: true,
				tableData: [],
				Dform: {
					userName: "",
					name: "",
					schoolName: "",
					mobile:""
				},
				pageInfo: {
					pageSize: "10",
					page: "1",
				},
				titleValue: '',
				AddShow: false,
				total: '',
				detailsObj: {},
				upShow: false,
				schoolList: [],
				gradeDataList: [],
				classList: [],
				schoolListTopId: '',
				gradeDataListTopId: '',
				classListTopId: '',
				schoolListTop: [],
				gradeDataListTop: [],
				classListTop: [],
				tempFile: "", //文件

			};
		},
		created() {
			this.Lookteacher()
			this.schoolOrUserManagementTeacherListSearch()
		},
		
		mounted() {
			this.schoolPost(false)
		},
		
		methods: {
			getFile(event) {
				this.tempFile = event.target.files[0];
			},
			
			xiazaiclick() {
				window.location.href = 'https://peizhe-1315512235.cos.ap-guangzhou.myqcloud.com/gts/teacher.xls'
			},
			
			//批量导入
			bulk_import() {
				this.upShow = true
			},
			
			// 文件上传
			uploadClick() {
				let index = this.tempFile.name.lastIndexOf(".");
				let fileName = this.tempFile.name.substr(index + 1);
				var filetypes = [
					"jpg",
					"png",
					"gif",
					"jpeg",
					"doc",
					"ppt",
					"xls",
					"pdf",
					"docx",
					"xlsx",
				];
				if (filetypes.includes(fileName)) {
					if (this.tempFile) {
						let fileSize = this.tempFile.size / (1024 * 1024 * 60);
						if (this.tempFile.name) {
							let formData = new FormData();
							formData.append("file", this.tempFile);
							// console.log(this.tempFile,formData.getAll('file'));
							ImporBulkTeacher(formData, JSON.parse(localStorage.getItem('user')).id).then((res) => {
								// console.log(res,'学校-导入');
								// ElMessage({message: '教师批量导入成功',type: 'success',})
								this.upShow = false
								this.handleExport(res.data, '教师导入报表.xls')

							}).catch((err) => {
								// console.log();
								ElMessage.error("上传失败")
							})
						}
					}
				} else {
					ElMessage.error("请上传jpg,png,gif,jpeg,doc,ppt,xls,pdf,docx,xlsx格式的文件!")
				}
			},
			
			ExportTeacherInfo(){
				let params = {
					gradeId: this.gradeDataListTopId,
					classId: this.classListTopId,
					mobile: this.Dform.mobile,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					schoolId: this.schoolListTopId,
					schoolName: this.Dform.schoolName,
					userId: JSON.parse(localStorage.getItem('user')).id,
					userName: this.Dform.userName,
				}
				exportTeacherInfo(params).then((res)=> {
				  console.log(res.data,'导出');
				  this.handleExport(res.data,'教师信息.xls')
				  this.daochuValue = false
				}).catch((err)=> {
				  this.$message({
				    showClose: true,
				    message: '数据为空，不可导出',
				    type: 'error'
				  });
				})
			},


			deleteClick(item) {
				this.$confirm('确定删除该老师吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.deleteStatus(item)
				}).catch((err) => {
					this.$message({
						type: 'error',
						message: err.response.data.msg
					});
				});
			},

			// 删除
			deleteStatus(item) {
				console.log(item);
				const params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
					id: item.id
				}
				deleteTeacherInfo(params).then((res) => {
					console.log(res, 222);
					ElMessage.success('删除成功')
					this.schoolOrUserManagementTeacherListSearch()
				}).catch((err) => {
					console.log(err, 111);
					ElMessage.error('删除失败')
				})
			},

			reviseClick(item) {
				console.log(item, 666666);
				// this.detailsObj = item
				if(item.type == 0){
					// this.titleValue = "系统管理员修改"
					this.titleValue = "教职工修改"

				}else if(item.type == 1){
					// this.titleValue = "学校管理员修改"
					this.titleValue = "教职工修改"

				}else if(item.type == 2){
					// this.titleValue = "年级管理员修改"
					this.titleValue = "教职工修改"

				}else if(item.type == 3){
					// this.titleValue = "班级管理员修改"
					this.titleValue = "教职工修改"

				}else if(item.type == 4){
					this.titleValue = "教职工修改"
				}else{
					this.titleValue = ""
				}
				
				if (item.type == 1 || item.type == 2 || item.type == 3 || item.type == 4) {
					this.findTeacherInfoGet(item)
				}
			},
			
			
			
			Lookteacher() {
				let params = {
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				findTeacherInfo(params).then((res) => {
					console.log(res, '查看权限');
					this.teacherObj = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},

			findTeacherInfoGet(item) {
				let params = {
					userId: item.id,
				}
				findTeacherInfo(params).then((res) => {
					this.AddShow = true
					this.detailsObj = res.data.data
					console.log(res, '学校管理员详情');
				}).catch((err) => {
					console.log(err);
				})
			},
			AddClick() {
				this.titleValue = '新增学校管理员'
				this.AddShow = true
			},
			
			AddTeacher() {
				this.titleValue = '新增教职工'
				this.AddShow = true
			},
			
			daoRuClick() {
				this.titleValue = '新增年级管理员'
				this.AddShow = true
			},
			
			deriveFamily() {
				this.titleValue = '新增班级管理员'
				this.AddShow = true
			},
			
			addClick() {
				this.AddShow = false
				this.schoolOrUserManagementTeacherListSearch()
			},
			
			schoolOrUserManagementTeacherListSearch() {
				const params = {
					schoolName: this.Dform.schoolName,
					userName: this.Dform.userName,
					name: this.Dform.name,
					page: this.pageInfo.page,
					pageSize: this.pageInfo.pageSize,
					userId: JSON.parse(localStorage.getItem('user')).id,
					schoolId: this.schoolListTopId,
					gradeId: this.gradeDataListTopId,
					classId: this.classListTopId,
					mobile: this.Dform.mobile,
				}
				 schoolOrUserManagementTeacherList(params).then((res) => {
					console.log(res, '教师管理成功');
					res.data.data.list.forEach((item,index) => {
						if ( item.type == 1 ) {
							// 校长年级和班级显示为空
							item.gradeName = ''
							item.className = ''
						} else if ( item.type == 2 ) {
							// 年级主任班级显示为空
							item.className = ''
						}
						// this.$set(item,)
						console.log(item,444444444444);
						if (item.teacherJobList != null && item.teacherJobList.length ) {
							item.teacherJobList.forEach((item2)=> {
								console.log(item2,888,item2.gradeName+item2.className+item2.subjectName+item2.jobName);
								item.zhiwei= item2.gradeName+'-'+item2.className+'-'+item2.subjectName+'-'+item2.jobName
							})
						}
						//  this.getTeacherSubjectGet(item)
					});
					this.tableData = res.data.data.list
					this.total = res.data.data.total
					this.loading = false
					console.log(this.tableData,'教师-----------');
				}).catch((err) => {
					console.log(err, '教师管理失败');

				})
			},
			// async getTeacherSubjectGet (item) {
			// 	let params = {
			// 		orgId : item.schoolId,
			// 	}
			// 	await getTeacherSubject(params).then((res)=> {
			// 		console.log(res.data.data,'获取职位========');
			// 	})
			// },
			entrylogClick() {
				this.schoolOrUserManagementTeacherListSearch()

			},
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`);
				this.pageInfo.page = val
				this.schoolOrUserManagementTeacherListSearch()
			},
			
			handleExport(data, name) {
				// 动态创建iframe下载文件
				let fileName = name;
				if (!data) {
					return;
				}
				let blob = new Blob([data], {
					type: "application/octet-stream"
				});
				console.log(blob);
				if ("download" in document.createElement("a")) {
					// 不是IE浏览器
					let url = window.URL.createObjectURL(blob);
					let link = document.createElement("a");
					link.style.display = "none";
					link.href = url;
					link.setAttribute("download", fileName);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link); // 下载完成移除元素
					window.URL.revokeObjectURL(url); // 释放掉blob对象
				} else {
					// IE 10+
					window.navigator.msSaveBlob(blob, fileName);
				}
			},
			
			classPost() {
				let params = {
					page: '1',
					pageSize: '999',
				}
				this.class_loading = true;
				findClassList(params, this.gradeDataListTopId).then((res) => {
					this.classListTop = res.data.data;
					this.class_loading = false;
				}).catch((err) => {
					console.log(err);
					this.class_loading = false;
				})
			},
			
			gradePost() {
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, this.schoolListTopId).then((res) => {
					console.log(res, '年级列表');
					this.gradeDataListTop = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			
			schoolPost(schooName) {
				if (this.schoolList.length > 0) {
					return;
				}
				let params = JSON.parse(localStorage.getItem('user')).id;
				schoolList(params).then((res) => {
					console.log(res, '学校列表');
					this.schoolList = res.data.data
					this.schoolListTop = res.data.data
				}).catch((err) => {
					console.log(err);
				})
			},
			
			schoolClickTop() {
				this.gradeDataListTopId = ''
				this.classListTopId = ''
				this.gradeDataListTop = []
				this.classListTop = []
			},
			
			classClickTop() {
				this.classListTopId = ''
				this.classListTop = []
			},
			
			schoolClick() {
				this.Dform.classes = ''
				this.Dform.classes2 = ''
				this.gradeDataList = []
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				gradeList(params, this.Dform.region).then((res) => {
					console.log(res, '年级列表');
					this.gradeDataList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
			
			classClick() {
				this.Dform.classes2 = ''
				this.classList = []
				let params = {
					page: '1',
					pageSize: '999',
				}
				findClassList(params, this.Dform.classes).then((res) => {
					console.log(res, '班级列表');
					this.classList = res.data.data;
				}).catch((err) => {
					console.log(err);
				})
			},
		},
	};
</script>

<style scoped lang="scss">
	.fuzzy-matching-box {
		padding-top: 20px;
		// overflow: hidden;
		// overflow: auto;
		width: 100%;
		height: 96%;
		background-color: #fff;
		border-radius: 8px;

		.query-button {
			margin: 2px;
			padding: 0px;
			font-size: 15px;
			font-weight: 700;
		}
		
		.subject-wrapper {
		  white-space: normal;  /* 允许内容换行 */
		  word-break: break-all;  /* 强制单词换行 */
		  line-height: 1.8;  /* 调整行高 */
		}

		.title-top {
			padding: 20px 20px;
			
		}

		.fuzzy-matching-top {
			height:130px;
			background-color: #fff;
			border-radius: 8px;

			.top-first-line {
				/deep/ {
					.el-form-item--small .el-form-item__label {
						// background-color: red;
						font-size: 16px;
					}
				
					.el-select--small {
						width: 100%
					}
				
					.el-form-item--small .el-form-item__label {
						width: 110px;
						text-align: right;
						height: 35px;
						line-height: 35px;
						font-weight: 700;
					}
				
					.el-input {
						width: 100%;
						height: 35px;
					}
				
					.el-select--small .el-select__wrapper {
						height: 35px !important;
					}
				}
			}

			.the-second-line {
				margin-top: 15px;
				position: relative;

				.query-button {
					position: absolute;
					right: 300px;
					padding: 16px 24px;
				}
			}

			/deep/ {
				.el-range-editor--small.el-input__wrapper {
					height: 35px;
					line-height: 35px;
				}
			}
		}

		.fuzzy-matching-content {
			height: 20px;
			line-height: 20px;
			margin-bottom: 10px;

			/deep/ {
				.el-button {
					margin-left: 50px;
					font-size: 16px;

				}
			}
		}

		.upload-lef {
			margin-left: 50px;
			margin-top: 30px;

		}

		.fuzzy-matching-bottom {
			// position: absolute;
			padding: 20px;

			.textButton {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
			}

			.shanchuBtn {
				// background-color: pink;
				margin: 2px;
				padding: 0px;
				font-size: 15px;
				font-weight: 700;
				color: red;
			}

			.box_le_zhi {
				text-align: left !important;
			}

			/deep/ {
				.el-table .cell {  
					white-space: pre-line;  
				}  
				.el-table th.el-table__cell>.cell {
					// height: 30px;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
				}

				.el-table td.el-table__cell div {
					text-align: center;
					// height: 40px;
					line-height: 30px;
					border: 0;
					font-size: 16px;
					color: black;
				}

				.el-table:not(.el-table--border) .el-table__cell {
					border: 0;
				}

				.el-button--small {
					padding-left: 19px;
				}
			}

			.block-fenye {
				margin-left: 1000px;
				margin-top: 15px;
			}
		}

	}
</style>